import React, { Component } from 'react';

interface State {
  error: boolean;
}

class ErrorBoundary extends Component<{}, State> {
  state = {
    error: false
  };

  componentDidCatch() {
    this.setState({
      error: true
    });
  }

  render() {
    return (
      <>
        {this.state.error ? (
          <div>uh-oh, unfortunately some error occured</div>
        ) : (
          <>{this.props.children}</>
        )}
      </>
    );
  }
}

export default ErrorBoundary;
